import type { CSSProperties } from 'react';
import { parseHexColor } from './presentation';
import type { ImageOverlay } from './types';

export const DEFAULT_IMAGE_OVERLAY: ImageOverlay = {
  enabled: false,
  color: '#000000',
  opacity: 50,
};

export function imageOverlayRgba(
  overlay: ImageOverlay | undefined,
): string | undefined {
  if (!overlay?.enabled) {
    return undefined;
  }
  const rgb = parseHexColor(overlay.color);
  if (!rgb) {
    return undefined;
  }
  const alpha = Math.min(100, Math.max(0, overlay.opacity)) / 100;
  return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${alpha})`;
}

export function backgroundImageLayers(
  imageUrl: string,
  overlay: ImageOverlay | undefined,
): string {
  const layers: string[] = [];
  const rgba = imageOverlayRgba(overlay);
  if (rgba) {
    layers.push(`linear-gradient(0deg, ${rgba}, ${rgba})`);
  }
  layers.push(`url(${imageUrl})`);
  return layers.join(', ');
}

export function clipRadiusOverflowStyle(
  radiusCss: string | undefined,
  editorMode = false,
): Pick<CSSProperties, 'overflow'> {
  if (!radiusCss || editorMode) {
    return {};
  }
  return { overflow: 'hidden' };
}

export function surfaceBackgroundImageStyle(
  imageUrl: string | undefined,
  overlay: ImageOverlay | undefined,
): Pick<
  CSSProperties,
  'backgroundImage' | 'backgroundSize' | 'backgroundPosition' | 'backgroundRepeat'
> {
  if (!imageUrl) {
    return {};
  }
  return {
    backgroundImage: backgroundImageLayers(imageUrl, overlay),
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  };
}
